import type { FC, ReactElement } from 'react';

import { WALLET_PUBLIC_ENABLED } from 'constants/walletPublic';
import { ErrorPage } from 'modules/E404/Error';

type WalletPublicGuardProps = {
  children: ReactElement;
};

export const WalletPublicGuard: FC<WalletPublicGuardProps> = ({ children }) => {
  if (!WALLET_PUBLIC_ENABLED) {
    return <ErrorPage code={404} embedded compact />;
  }
  return children;
};
